<template lang="pug">
  .zoom-configuration
    transition(name="fade")
      .disabled-overlay.d-flex.align-end.justify-center(
        v-if="disabled"
      )
        div.text-center.pb-5
          v-icon.large-lock(color="white") mdi-lock
          slot(name="disabled-reason")
            h3.white--text {{ disabledReason }}
    .d-flex.mb-3.align-center
      svg-zoom.mr-2.zoom
      .text-h6 Параметры Zoom-конференции
    validation-provider(
      rules="required"
      :disabled="disabled"
      name="Наименование конференции"
      v-slot="{ errors, valid }"
    )
      v-text-field(
        :value="value.topic"
        name="name"
        label="Наименование конференции"
        :error-messages="errors"
        filled
        rounded
        persistent-hint
        hint="Может совпадать с названием урока"
        @input="update('topic', $event)"
      )
    v-switch(
      v-model="setPassword"
      label="Установить пароль"
    )
    validation-provider(
      v-if="setPassword"
      rules="required"
      vid="password"
      name="Пароль"
      :disabled="disabled"
      v-slot="{ errors }"
    )
      v-text-field(
        :value="value.password"
        label="Пароль для входа"
        :error-messages="errors"
        filled
        rounded
        @input="update('password', $event)"
      )
    v-switch.mt-0(
      :input-value="value.settings.participant_video"
      label="Камера участника"
      @change="switchSettings('participant_video', $event)"
    )
    v-switch.mt-0(
      :input-value="value.settings.host_video"
      label="Камера ведущего"
      @change="switchSettings('host_video', $event)"
    )
</template>

<script>
import SvgZoom from '@/assets/zoom.svg';

export default {
  components: {
    SvgZoom,
  },
  props: {
    value: { type: Object, default: () => ({}) },
    lesson: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    disabledReason: { type: String, default: 'Заблокированно' },
  },
  data() {
    return {
      setPassword: !!this.value.password,
    };
  },
  computed: {
    lessonName() {
      return this.lesson.name;
    },
    lessonDuration() {
      return this.lesson.duration;
    },
    lessonDateStart() {
      return this.lesson.date_start;
    },
  },
  watch: {
    setPassword(val) {
      if (!val) this.update('password', null);
    },
    lessonName(val) {
      this.update('topic', val);
    },
    lessonDuration(val) {
      this.update('duration', val);
    },
    lessonDateStart(val) {
      this.update('start_time', val);
    },
  },
  methods: {
    update(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
    switchSettings(key, val) {
      this.update('settings', { ...this.value.settings, [key]: val });
    },
  },
};
</script>

<style scoped>
.zoom {
  height: 40px;
}
.disabled-overlay {
  position: absolute;
  background: rgba(0,0,0,0.4);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.large-lock {
  font-size: 100px;
}
</style>
